import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Icons } from "../utility/icons"
import { useMsal } from '@azure/msal-react';
import { variables } from "../utility/variables";

const Navbar = ({ userFullName, isPAAdmin, isVendorAdmin, callback = null }) => {
  const { instance } = useMsal();
  
  // temp
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);
  
  return (
    //user &&
    <nav id="rosterNav">
      <div className="flex justify-between">
        <div><h1 className="text-2xl">PA Engineering Vendor Portal</h1></div>
        <span>Hello, {userFullName} <a className="underline cursor-pointer" style={{ textDecoration: "underline", color: "rgb(34 211 238)" }} onClick={callback}>Sign Out</a></span>
      </div>
      <div className="flex justify-between">
        <div>
          <ul className="flex justify-start items-center py-4 my-1 gap-4 text-cyan-400">
            <li>
              <NavLink to={"/agreements"} className={"p-2 rounded-lg bg-white border border-cyan-400 text-cyan-400"}>
                Agreements
              </NavLink>
            </li>
            <li>
              <NavLink to={"/roster"} className={"p-2 rounded-lg bg-white border border-cyan-400 text-cyan-400"}>
                Roster
              </NavLink>
            </li>
            {
              // (currentUserRoles === '2' || currentUserRoles === '3') //user?.roleId == 3 // RoleID 3 = PA Admin
              // &&
              ((isPAAdmin) || (isVendorAdmin)) &&
              <li>
                <button id="dropdownDefaultButton" data-dropdown-toggle="dropdown" className={"p-2 rounded-lg bg-white border border-cyan-400 text-cyan-400"} type="button" onClick={toggleDropdown}>
                  <span className="inline-flex items-center">Admin {Icons.DropdownIcon({ className: "w-4 h-4 align-middle fill-current" })}</span>
                </button>
                { isOpen &&
                  <div id="dropdown" className={"absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"}>
                    <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
                      <li>
                        <NavLink to={"/admin/user"} className={"block px-4 py-2 hover:bg-gray-100"} onClick={toggleDropdown}>Users</NavLink>
                      </li>
                      <li>
                        <NavLink to={"/admin/contactinfo"} className={"block px-4 py-2 hover:bg-gray-100"} onClick={toggleDropdown}>Contact Info</NavLink>
                      </li>
                  </ul>
                </div>
                }
              </li>
              // <li>
              //   <NavLink to={"/user"} className={"p-2 rounded-lg bg-white border border-cyan-400 text-cyan-400"}>
              //     Admin
              //   </NavLink>
              // </li>
            }
          </ul>
        </div>
        <div  style={{ textAlign: "right", fontSize: "14px" }}>
          <a href="https://www.panynj.gov/content/dam/port-authority/pdfs/-available-engineering-documents/roster-system-vendor-portal-user-guide.zip" style={{ textDecoration: "underline", color: "rgb(34 211 238)" }} download="roster-system-vendor-portal-user-guide.zip">User Guide</a>
          <br></br>
          <a href="mailto:EngRosterSupport@panynj.gov" class="email-btn">📧Support Contact </a>
        </div>
      </div>
      
    </nav>
    
  );
}

export default Navbar;
